// extracted by mini-css-extract-plugin
export default {"row":"BuildGrid_row__i50Ge","col":"BuildGrid_col__4r1xc","placeholder":"BuildGrid_placeholder__8rK7k"};